import {UserModel} from '../authentication/user.model';

export class DescriptionModel {

  _id: string;

  'da-DK': string;
  'de-DE': string;
  'en-GB': string;
  'en-US': string;
  'es-AR': string;
  'es-CL': string;
  'es-CO': string;
  'es-ES': string;
  'es-GT': string;
  'es-MX': string;
  'es-PE': string;
  'es-PR': string;
  'es-US': string;
  'fr-FR': string;
  'is-IS': string;
  'lt-LT': string;
  'nb-NO': string;
  'pt-BR': string;
  'pt-PT': string;
  'sv-SE': string;

  static generateModel(json: any): DescriptionModel {

    const descr = new DescriptionModel();
    descr._id = json._id;
    descr['da-DK'] = json['da-DK'];
    descr['de-DE'] = json['de-DE'];
    descr['en-GB'] = json['en-GB'];
    descr['en-US'] = json['en-US'];
    descr['es-AR'] = json['es-AR'];
    descr['es-CL'] = json['es-CL'];
    descr['es-CO'] = json['es-CO'];
    descr['es-ES'] = json['es-ES'];
    descr['es-GT'] = json['es-GT'];
    descr['es-MX'] = json['es-MX'];
    descr['es-PE'] = json['es-PE'];
    descr['es-PR'] = json['es-PR'];
    descr['es-US'] = json['es-US'];
    descr['fr-FR'] = json['fr-FR'];
    descr['is-IS'] = json['is-IS'];
    descr['fr-FR'] = json['fr-FR'];
    descr['lt-LT'] = json['lt-LT'];
    descr['nb-NO'] = json['nb-NO'];
    descr['pt-BR'] = json['pt-BR'];
    descr['pt-PT'] = json['pt-PT'];
    descr['sv-SE'] = json['sv-SE'];

    return descr;

  }

  static generateModels(jsonList: any[]): DescriptionModel[] {

    const list = [];

    for (const json of jsonList) {
      list.push(this.generateModel(json));
    }

    return list;

  }

  hasAllTranslations(cultureList: string[]): boolean {

    for (const culture of cultureList) {
      if (!this[culture]) {
        return false;
      }
    }

    return true;

  }

  stringForCulture(culture: string) {

    return this[culture];
  }

  stringForUser(): string {

    if (UserModel.getCurrent()) {
      return this.stringForCulture(UserModel.getCurrent().culture);
    }

    return '';
  }

}
